import React from 'react';
import { ChecklistItem } from '../types/checklist';

interface ItemRowProps {
  item: ChecklistItem;
  onCheck: () => void;
  onInfo: (e: React.MouseEvent) => void;
}

export function ItemRow({ item, onCheck, onInfo }: ItemRowProps) {
  return (
    <div
      onClick={onCheck}
      className="px-2 sm:px-3 py-2 sm:py-2.5 flex items-center justify-between hover:bg-navy-700 cursor-pointer transition-colors"
    >
      <div className="flex items-center gap-2 flex-1 min-w-0">
        <input
          type="checkbox"
          checked={item.checked}
          onChange={onCheck}
          onClick={(e) => e.stopPropagation()}
          className="w-4 h-4 rounded border-navy-600 bg-navy-700 text-yellow-400 focus:ring-yellow-500 cursor-pointer flex-shrink-0"
        />
        <div className="flex-1 min-w-0">
          <div className="text-xs sm:text-sm text-white truncate">{item.text}</div>
          <div className="text-xs text-gray-400 line-clamp-1">{item.description}</div>
        </div>
      </div>
      <button
        type="button"
        onClick={(e) => { e.stopPropagation(); onInfo(e); }}
        className="px-2 py-1 text-xs text-gray-300 hover:text-white hover:bg-navy-600 rounded flex-shrink-0 ml-2"
      >
        Info
      </button>
    </div>
  );
}